import React from "react";
import Box from "@mui/material/Box";
import useStyled from "../../hooks/useStyled";
import { ButtonBase } from "@mui/material";
const { styled } = useStyled();

 
const getThumbnailHeight169 = (width) => {
  return width * 0.5625;
};

// eslint-disable-next-line no-unused-vars
const getThumbnailHeight43 = (width) => {
  return width * 0.75;
};

const Container = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "hasMinWidth" && prop !== "scaleOnHover",
})(({ theme, hasMinWidth, scaleOnHover }) => ({
  position: "relative",
  height: 220,
  borderRadius: "6px",
  border: "2px solid #74748080",
  boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.75)",
  overflow: "hidden",
  ...(hasMinWidth === "true" && {
    [theme.breakpoints.down("md")]: {
      minWidth: 220,
      height: getThumbnailHeight169(220),
    },
    [theme.breakpoints.up("md")]: {
      minWidth: 220,
      height: getThumbnailHeight169(220),
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: 320,
      height: getThumbnailHeight169(320),
    },
  }),
  ...(scaleOnHover === "true" && {
    transition: "scale 400ms",
    "&:hover": {
      scale: "1.07",
    },
    "&:focus-within": {
      scale: "1.07",
    },
  }),
  "&:focus-within": {
    border: `3px ${theme.palette.blue200.main} solid`,
    borderRadius: 5
  }
}));

const ButtonBaseStyled = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== "hasImage",
})(({ theme, hasImage }) => ({
  position: "absolute",
  height: "100%",
  width: "100%",
  left: 0,
  top: 0,
  overflow: "hidden",
  ...(hasImage === "true" && {
    backgroundImage:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.3) -30%, rgba(0, 0, 0, 0.8) )",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  }),
  "&:focus": {
    "& .video-overlay-container": {
      border: `2px ${theme.palette.blue200.main} solid`,
    },
    // border: `2px ${theme.palette.blue200.main} solid`,
    // borderRadius: "6px",
    "& .sf-stack": {
      left: theme.spacing(1),
      bottom: theme.spacing(1),
      transform: "translate(0, 0)",
    },
    "& .video-overlay-container .icon-container": {
      left: "0",
      transform: "scale(0.7) translateX(0)",
    },
    "& .video-overlay-container video": {
      opacity: 1,
    },
  },
}));

const ImageStyled = styled("img")(({ theme }) => ({
  position: "absolute",
  height: "100%",
  width: "100%",
  left: 0,
  top: 0,
  zIndex: -1,
}));

const SFBaseThumbnail = ({
  onClick = null,
  image = null,
  lazyLoad = false,
  scaleOnHover = false,
  hasMinWidth = true,
  label = null,
  children,
  className = ""
}) => {
  const hasImage = image !== null;

  const content = (
    <>
      {image && (
        <ImageStyled
          {...(lazyLoad ? { "data-splide-lazy": image } : { src: image })}
        />
      )}
    </>
  );

  return (
    <Container
      hasMinWidth={hasMinWidth.toString()}
      scaleOnHover={scaleOnHover.toString()}
      className={scaleOnHover ? "scale-on-hover" : ""}
    >
      {onClick ? (
        <ButtonBaseStyled hasImage={hasImage.toString()} onClick={onClick} aria-label={label} className={className}>
          {children}
        </ButtonBaseStyled>
      ) : (
        <ButtonBaseStyled hasImage={hasImage.toString()} disabled aria-label={label} className={className}>
          {children}
        </ButtonBaseStyled>
      )}
      {content}
    </Container>
  );
};

export default SFBaseThumbnail;
